import React from 'react';
import Currency from '../Currency';
import { CostTitlePurchaseLabelStyled, CostTitlePurchaseStyled } from './CostTitlePurchase.styles';
import NoPermissionsErrorMessage from '../../shared/permissions/NoPermissionsErrorMessage';

interface ICostTitlePurchase {
  className?: string;
  name: string;
  value: number;
  hasEditPermissions?: boolean;
}
export default class CostTitlePurchase extends React.Component<ICostTitlePurchase> {
  public render() {
    const { className, name, value, hasEditPermissions } = this.props;
    return (
      <CostTitlePurchaseStyled className={className}>
        <CostTitlePurchaseLabelStyled>
          <div>
            {name} &nbsp;
            <NoPermissionsErrorMessage hasPermissions={hasEditPermissions} />
          </div>
        </CostTitlePurchaseLabelStyled>
        <Currency value={value} />
      </CostTitlePurchaseStyled>
    );
  }
}
